import * as React from "react";
import { Tooltip } from "antd";
import CurrencyInput from "../../../../../components/CurrencyInput";
import PercentageInput from "../../../../../components/PercentageInput";
import Select from "../../../../../components/Select";
import Radio from "../../../../../components/Radio";
import Checkbox from "../../../../../components/Checkbox";
import Slider from "../../../../../components/Slider";
import Input from "../../../../../components/Input";
import InputTag from "../../../../../components/Input-tag";
import { textInputTypes, optionTypes } from "../../../constants/input-types";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import Skeleton from "react-loading-skeleton";
import { Settings } from "@mui/icons-material";
import { MAX_TEXT_INPUT_CHAR_LIMIT } from "../../../../../constant";

const formType = {
  range: Slider,
  checkbox: Checkbox,
  select: Select,
  multi_select: Select,
  radio: Radio,
  input: Input,
  number: Input,
  input_tag: InputTag,
  url: Input,
};

const Forms = ({
  title,
  populateFieldsLoader = {},
  populateLoader = {},
  populateHelper,
  index,
  data,
  form,
  setForm,
  onChange,
  onChangeInput,
  currentStep,
  broadOptions,
  narrowOptions,
  supplyChainOptions,
  naicsSectorOptions,
  acquireFiveOptions,
  acquireSixOptions,
  acquireEightOptions,
  descriptionLoader,
  populateDescriptionHelper,
}) => {
  // CONST VALS
  const isBroadSpec = data.key === "broad_specialty_input";
  const isNarrowSpec = data.key === "narrow_specialty_input";
  const isSupplyChain = data.key === "supply_chain_dropdown";
  const isNaicsSector = data.key === "NAICS-Sub-Dropdown";
  const isAcquireFive = data.key === "acquire-five";
  const isAcquireSix = data.key === "acquire-six";
  const isAcquireEight = data.key === "acquire-eight";
  const isAcquireThree = data.key === "acquire-three";
  const isDescription = data.key === "description_input";
  const isUrl = data.key === "url_input";
  const isFlorenceRankRecommendation = data.key === "user_preferred_ranking_focus";
  const populateFieldView = isAcquireThree || isDescription || isUrl;
  const questionCategory = {
    "NAICS-Master-Dropdown": "NAICS Industry Classification System",
    primary_sector_input: "Conceptor Internal Specialty Classification System",
    url_input: "Populate Description by Company URL",
    description_input: "Populate Attributes by Description",
  };

  const isValueEmpty =
    data.label === "location_input"
      ? (!data.value && data.value !== 0) || data.value < 0
      : typeof data?.value !== "number" &&
        !data?.question[0]?.includes("optional") &&
        !data?.optional &&
        !data.value?.length;

  const category = questionCategory[data?.key];
  const buttonLoader = isUrl
    ? descriptionLoader
    : populateLoader[isAcquireThree ? "goals" : "attributes"];
  const fieldLoader =
    populateFieldsLoader[data.key] || (descriptionLoader && isDescription);
  const fieldOptions = isBroadSpec
    ? broadOptions
    : isNarrowSpec
      ? narrowOptions
      : isSupplyChain
        ? supplyChainOptions
        : isAcquireFive
          ? acquireFiveOptions
          : isAcquireSix
            ? acquireSixOptions
            : isNaicsSector
              ? naicsSectorOptions
              : isAcquireEight
                ? acquireEightOptions
                : data.options;

  // HANDLERS
  const populateGoalsAndAttributes = () => {
    const description = data.value ?? "";
    if (!description) {
      toast.error("Please provide a detailed description to populate the fields.");
      return;
    }
    populateHelper(description, title);
  };

  const populateDescription = () => {
    const url = data.value ?? "";
    populateDescriptionHelper(url, index + 1);
  };

  const change = (val) => {
    let opt = {};

    if (typeof data.value === "object") {
      onChangeInput(index, val, data.label);
    } else {
      if (val != "none") {
        if (isBroadSpec) {
          opt = broadOptions.filter((o) => o.value == val)[0];
        } else if (isNarrowSpec) {
          opt = narrowOptions.filter((o) => o.value == val)[0];
        } else if (isSupplyChain) {
          opt = supplyChainOptions.filter((o) => o.value == val)[0];
        } else if (isAcquireFive) {
          opt = acquireFiveOptions.filter((o) => o.value == val)[0];
        } else if (isAcquireSix) {
          opt = acquireSixOptions.filter((o) => o.value == val)[0];
        } else if (isNaicsSector) {
          opt = naicsSectorOptions.filter((o) => o.value == val)[0];
        } else if (isAcquireEight) {
          opt = acquireEightOptions.filter((o) => o.value == val)[0];
        } else {
          opt = data.options.filter((o) => o.value == val)[0];
        }
      }

      onChange(index, data.label, opt);
    }
  };
  const changeText = (e) => {
    const value = e.target.value;
    if (value.length > MAX_TEXT_INPUT_CHAR_LIMIT) {
    } else {
      onChangeInput(index, value, data?.label);
    }
  };

  const changeValue = (e) => {
    onChangeInput(index, e, data?.label);
  };

  const changeCurrency = (e) => {
    // let val = e.target.value.replace(/[^0-9.]+/g, "");
    onChangeInput(index, e.target.value.replace(/\$|,/g, ""), data?.label);
  };

  const changePercentage = (e) => {
    let val = e.target.value.replace(/[^0-9.]+/g);
    onChangeInput(index, val, data?.label);
  };

  return (
    <React.Fragment>
      {category && <h3 className="question-category">{category}</h3>}
      <div
        className="flex-1 dynamic-form"
        style={{ marginBottom: isDescription ? 0 : 20 }}
      >
        {data.question.map((qstn, q_i) => {
          return (
            <p className="question-wrapper" key={`question-${q_i}`}>
              <span dangerouslySetInnerHTML={{ __html: qstn }} />
              {data?.optionalText && <i> (optional)</i>}
              {fieldLoader && (
                <span className="spinner">
                  <Settings />
                </span>
              )}
            </p>
          );
        })}
        <div className={`field-wrapper ${populateFieldView ? "reduced" : ""}`}>
          {fieldLoader ? (
            <Skeleton height={32} baseColor="#eae7f2" />
          ) : (
            <>
              {optionTypes.includes(data.type) && (
                <React.Fragment>
                  {typeof data.value === "object"
                    ? React.createElement(formType[data.type], {
                        index: index,
                        data: data,
                        mode: "multiple",
                        value: data.value || [],
                        options: fieldOptions,
                        onChange: change,
                        showSearch: data?.showSearch,
                        withRating: isFlorenceRankRecommendation,
                        ratingOptions: data?.rating_options,
                      })
                    : React.createElement(formType[data.type], {
                        index: index,
                        value: data.value || [],
                        options: fieldOptions,
                        onChange: change,
                        showSearch: data?.showSearch,
                        withRating: isFlorenceRankRecommendation,
                        ratingOptions: data?.rating_options,
                      })}
                </React.Fragment>
              )}

              {data.type === "range" &&
                React.createElement(formType[data.type], {
                  value: data.value || 1,
                  range: [1, 10],
                  options: data.options,
                  onChange: changeValue,
                  question: data.question,
                })}

              {textInputTypes.includes(data.type) &&
                React.createElement(formType[data.type], {
                  type: data.type,
                  value: data.type == "number" ? (data.value ?? 0) : data.value || ``,
                  onChange: changeText,
                })}

              {data.type === "currency" && (
                <CurrencyInput
                  type="text"
                  value={data.value || ``}
                  onChange={changeCurrency}
                />
              )}

              {data.type === "percentage" && (
                <PercentageInput
                  type="text"
                  value={data.value || ``}
                  onChange={changePercentage}
                />
              )}
            </>
          )}
        </div>
        {isValueEmpty && (
          <div style={{ color: "red", fontSize: 13 }}>This field is required</div>
        )}
        {populateFieldView && (
          <div className="populate-button-wrapper">
            <Tooltip
              title={`Click to let the LLM fill in the ${
                isUrl
                  ? "Description field from your URL."
                  : isAcquireThree
                    ? "Goals section fields from your description."
                    : "Attributes section fields from your description."
              }`}
            >
              <button
                className="populate-field-view"
                style={{ minWidth: 180 }}
                onClick={() =>
                  isUrl ? populateDescription() : populateGoalsAndAttributes()
                }
              >
                {buttonLoader ? (
                  <BeatLoader size={8} color={"#000"} />
                ) : (
                  `Auto Populate ${
                    isUrl ? "Description" : isAcquireThree ? "Goals" : "Attributes"
                  }`
                )}
              </button>
            </Tooltip>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Forms;
